var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClear = function SvgClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 16c4.377 0 8-3.631 8-8 0-4.376-3.631-8-8.008-8C3.624 0 0 3.624 0 8c0 4.369 3.631 8 8 8m-2.635-4.706a.643.643 0 0 1-.643-.65c0-.173.062-.338.188-.456l2.172-2.18L4.91 5.835a.63.63 0 0 1-.188-.455c0-.368.282-.643.643-.643.18 0 .321.063.447.18L8 7.099l2.204-2.188a.6.6 0 0 1 .447-.188c.36 0 .651.282.651.643 0 .18-.055.321-.196.462l-2.18 2.18 2.172 2.173a.6.6 0 0 1 .196.463c0 .36-.29.651-.659.651a.62.62 0 0 1-.463-.188L8 8.926l-2.165 2.18a.65.65 0 0 1-.47.188"
  })));
};
export default SvgClear;